/**
 * Pure H OS · Phase D Wave 2 · Documents (types + live view).
 * MongoDB collection: `pureh_documents`.
 */
import { liveArray } from "../services/store";

export type DocumentKind = "contract" | "SOP" | "policy" | "deck" | "template" | "financial";
export type DocumentStatus = "draft" | "review" | "active" | "archived";

export type PhDocument = {
  id: string;
  title: string;
  kind: DocumentKind;
  owner: string;
  status: DocumentStatus;
  version: string;
  updatedRelative: string;
  tags: string[];
  confidential: boolean;
  body?: string;
};

export const DOCUMENTS: PhDocument[] = liveArray<PhDocument>("documents");
